import AbstractAxiosService from './AbstractAxiosService'
import { config } from '@/config'

export default class ContaoService extends AbstractAxiosService {
  constructor (options = {}) {
    super(options)
  }

	getReservationEvents({ code, date, locale = config.LOCALE }) {
		return this.makeRequest('get', '/api/reservation/location-events', { params: { code, date, locale } })
	}

	// Consent Log
	sendConsentLog({ consent, brand = config.BRAND, locale = config.LOCALE }) {
		return this.makeRequest('get', '/api/consent', { params: { brand, locale, ...consent } });
	}

  sendForm({ id, data, brand = config.BRAND, lang = config.LANGUAGE, locale = config.LOCALE }) {
    return this.makeRequest('post', '/api/form/:id/send', data, { path: { id }, params: { brand, locale, lang } });
	}
}
